import { expVal } from '@atlassian/jira-feature-experiments';

const jiraAiDeeplinkInHeaderRelayProvider = {
	get(): boolean {
		return expVal('jira-ai-deeplink-in-header', 'isEnabled', false);
	},
};

export default jiraAiDeeplinkInHeaderRelayProvider;
